import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { Hero } from "../sections/Hero";
import { Marquee } from "../components/Marquee";
import { QuestionSection, ConventionalSection, MethodSection } from "../sections/SectionsA";
import { ArchitectureSection, FrameworksSection, DeliverablesSection } from "../sections/SectionsB";
import {
  DecisionSupportSection,
  EngagementsSection,
  WhyEnexurSection,
  FinalCtaSection,
} from "../sections/SectionsC";
import { scrollToId } from "../lib/scroll";

const MARQUEE_ITEMS = [
  "India Opportunity Index™",
  "Account Priority Score™",
  "Partner DNA™",
  "Entry Risk Score™",
  "Market Validation Score™",
  "Market Readiness Score™",
  "Intelligence Vault™",
  "Red Team India™",
  "Voice of India™",
  "First 10 Meetings Pack",
  "90-Day Activation Blueprint",
];

export default function IndiaMarketIntelligence() {
  const { hash } = useLocation();

  useEffect(() => {
    document.title = "ENEXUR India Market Intelligence™ — Decide with Evidence";
  }, []);

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash.slice(1)), 80);
      return () => clearTimeout(t);
    }
  }, [hash]);

  return (
    <main className="min-h-screen">
      <Nav />
      <Hero />
      <Marquee items={MARQUEE_ITEMS} />
      <QuestionSection />
      <ConventionalSection />
      <MethodSection />
      <ArchitectureSection />
      <FrameworksSection />
      <DeliverablesSection />
      <DecisionSupportSection />
      <EngagementsSection />
      <WhyEnexurSection />
      <FinalCtaSection />
      <Footer />
    </main>
  );
}
